var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92012 12.7132C2.78394 12.4975 2.71584 12.3897 2.67772 12.2234C2.64909 12.0985 2.64909 11.9015 2.67772 11.7766C2.71584 11.6103 2.78394 11.5025 2.92012 11.2868C4.04553 9.50484 7.3954 5 12.5004 5C17.6054 5 20.9553 9.50484 22.0807 11.2868C22.2169 11.5025 22.285 11.6103 22.3231 11.7766C22.3517 11.9015 22.3517 12.0985 22.3231 12.2234C22.285 12.3897 22.2169 12.4975 22.0807 12.7132C20.9553 14.4952 17.6054 19 12.5004 19C7.3954 19 4.04553 14.4952 2.92012 12.7132Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5004 15C14.1573 15 15.5004 13.6569 15.5004 12C15.5004 10.3431 14.1573 9 12.5004 9C10.8435 9 9.5004 10.3431 9.5004 12C9.5004 13.6569 10.8435 15 12.5004 15Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView1);
export default __webpack_public_path__ + "static/media/view (1).815f02a4e8c5b53bcea089196eafc8f3.svg";
export { ForwardRef as ReactComponent };